import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IPatientCaseRejectionReasonHF, defaultValue } from 'app/shared/model/patient-case-rr-hf.model';

export const ACTION_TYPES = {
  FETCH_PATIENT_CASE_RR_HF_LIST: 'patientCaseRrHF/FETCH_PATIENT_CASE_RR_HF_LIST',
  FETCH_PATIENT_CASE_RR_HF: 'patientCaseRrHF/FETCH_PATIENT_CASE_RR_HF',
  FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE: 'patientCaseRrHF/FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE',
  FETCH_PATIENT_CASE_RR_HF_BY_HF: 'patientCaseRrHF/FETCH_PATIENT_CASE_RR_HF_BY_HF',
  FETCH_PATIENT_CASE_RR_HF_BY_RR_HF: 'patientCaseRrHF/FETCH_PATIENT_CASE_RR_HF_BY_RR_HF',
  CREATE_PATIENT_CASE_RR_HF: 'patientCaseRrHF/CREATE_PATIENT_CASE_RR_HF',
  UPDATE_PATIENT_CASE_RR_HF: 'patientCaseRrHF/UPDATE_PATIENT_CASE_RR_HF',
  DELETE_PATIENT_CASE_RR_HF: 'patientCaseRrHF/DELETE_PATIENT_CASE_RR_HF',
  RESET: 'patientCaseRrHF/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPatientCaseRejectionReasonHF>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type PatientCaseRRHFState = Readonly<typeof initialState>;

// Reducer

export default (state: PatientCaseRRHFState = initialState, action): PatientCaseRRHFState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_HF):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_RR_HF):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PATIENT_CASE_RR_HF):
    case REQUEST(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_HF):
    case REQUEST(ACTION_TYPES.DELETE_PATIENT_CASE_RR_HF):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_HF):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_RR_HF):
    case FAILURE(ACTION_TYPES.CREATE_PATIENT_CASE_RR_HF):
    case FAILURE(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_HF):
    case FAILURE(ACTION_TYPES.DELETE_PATIENT_CASE_RR_HF):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_HF):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_RR_HF):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PATIENT_CASE_RR_HF):
    case SUCCESS(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_HF):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PATIENT_CASE_RR_HF):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/patient-case-rejection-reason-hf';

// Actions

export const getEntities: ICrudGetAllAction<IPatientCaseRejectionReasonHF> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_LIST,
  payload: axios.get<IPatientCaseRejectionReasonHF>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity = (patientCaseId: string, hfId: string) => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${hfId}`;
  return {
    type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF,
    payload: axios.get<IPatientCaseRejectionReasonHF>(requestUrl),
  };
};

export const getEntitiesByPatientCase = (patientCaseId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_PATIENT_CASE,
  payload: axios.get<IPatientCaseRejectionReasonHF>(`${apiUrl}/by-patient-case/${patientCaseId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByHF = (hfId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_HF,
  payload: axios.get<IPatientCaseRejectionReasonHF>(`${apiUrl}/by-hf/${hfId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByRrHF = (rrHfId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_HF_BY_RR_HF,
  payload: axios.get<IPatientCaseRejectionReasonHF>(`${apiUrl}/by-rejection-reason-hf/${rrHfId}?cacheBuster=${new Date().getTime()}`),
});

export const createEntity: ICrudPutAction<IPatientCaseRejectionReasonHF> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PATIENT_CASE_RR_HF,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const updateEntity: ICrudPutAction<IPatientCaseRejectionReasonHF> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PATIENT_CASE_RR_HF,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity = (patientCaseId: string, hfId: string) => async dispatch => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${hfId}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PATIENT_CASE_RR_HF,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
